/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: I18nFixture
// source: i18n/*/*.json

import type { LibraryType } from "@pdfking/i18n"
import type { EnumUnion } from "@pdfking/structs"
import { LibraryFromJson } from "@pdfking/i18n"

const raw: LibraryType<Readonly<{
  pdfview: EnumUnion<{
    ADD_BLANK_PAGES: undefined
    BLANK_PAGE: undefined
    CHANGE_DARK_MODE: undefined
    CHANGE_LANGUAGE: undefined
    COLORS: undefined
    COLOR_WARNING: { colors: unknown; names: unknown }
    CONTENT: undefined
    FIRST_PAGE: undefined
    GROUP_COVER: undefined
    GROUP_DOUBLE: undefined
    GROUP_SINGLE: undefined
    HISTORY_BACK: undefined
    HISTORY_FORWARD: undefined
    LAST_PAGE: undefined
    LOADING_DONE: undefined
    NEXT_PAGE: undefined
    PAGE_COUNT: { count: unknown }
    PAGE_COUNT_WARNING: { name: unknown; expected: unknown; selected: unknown }
    PREV_PAGE: undefined
    REORDER: undefined
    TEMPLATE_FEATURE_1: undefined
    TEMPLATE_FEATURE_2: undefined
    TEMPLATE_FEATURE_3: undefined
    TEMPLATE_FEATURE_4: undefined
    VIEW_3D: undefined
    VIEW_FREE: undefined
    VIEW_STRIPE: undefined
    ZOOM_IN: undefined
    ZOOM_OUT: undefined
  }>
}>, "en" | "fr" | "it"> = {
  pdfview: {
    en: () => import("../i18n/pdfview/en.json"),
    fr: () => import("../i18n/pdfview/fr.json"),
    it: () => import("../i18n/pdfview/it.json"),
  },
} as const

export const { pdfview } = LibraryFromJson(raw)
